angular.module('gymsystem.util').factory('CreditPaymentDialog', ['$modal', function ($modal) {
        return {
            open: function (option) {
                return $modal.open({
                    template: '<economy-credit-payment />',
                    controller: ['$scope', function ($scope) {
                            $scope.option = option || {};
                        }]
                });
            }
        };
    }]);
gs.component('economyCreditPayment', {
    templateUrl: '/components/economy/credit-payment.html',
    link: function (DI) {
        var _this = this;
        this.getPaymentMethodForField = DI.$rootScope.getPaymentMethodForField;
        var option = this.$parent.option;
        var bundleId = option.bundleId;
        var courseBookingId = option.courseBookingId;
        var paymentsIds = option.paymentsIds;
        this.isBooking = false;
        this.loadingStatus = {};
        this.methods = [];
        this.form = {
            course_free_canceling: false,
            course_no_refund: false,
            paid_amount: 0,
            fee: 0,
            amount: 0,
            products: []
        };
        this.onChange = function () { return recalculate(); };
        var updateMethods = function () {
            var amount = _this.form.amount;
            _this.methods = DI.get('paymentMethods').get().filter(function (m) {
                if (!m.active)
                    return false;
                if (m.id == 'stripe') {
                    return details.balance.stripe && amount && details.balance.stripe >= amount;
                }
                if (m.id == 'swishi' && details.swish_account)
                    return details.balance.swishi && amount && details.balance.swishi >= amount;
                if (m.id == 'swish' && details.swish_account)
                    return details.balance.swish && amount && details.balance.swish >= amount;
                if (m.id == 'bank') {
                    if (details.cancelinfo && !details.cancelinfo.methods.includes('bank'))
                        return false;
                    return DI.$rootScope.hasModule('Payout');
                }
                if (m.id.startsWith('adyen-')) {
                    return amount && details.balance[m.id] && amount <= details.balance[m.id];
                }
                if (m.id == 'epassi') {
                    return amount && details.balance.epassi && amount <= details.balance.epassi;
                }
                return m.id == 'valuecard';
            });
            // Payments paid with epassi can only be credited with epassi
            if ('epassi' in details.balance) {
                _this.methods = _this.methods.filter(function (m) { return m.id == 'epassi'; });
            }
            // Currently crediting invoices paid with adyen payment method back to adyen is not supported (Only bank/valuecard is supported)
            if (details.invoice_id) {
                _this.methods = _this.methods.filter(function (m) { return !m.id.startsWith('adyen-'); });
            }
            // Invoices paid with Swish can currently not be credited back to Swish because of backend limitation (Not implemented)
            if (details.invoice_id) {
                _this.methods = _this.methods.filter(function (m) { return m.id != 'swish' && m.id != 'swishi'; });
            }
            _this.activeMethod = null;
        };
        var details = {};
        var args;
        if (bundleId)
            args = 'bundle_id=' + bundleId;
        else if (courseBookingId)
            args = 'coursebooking_id=' + courseBookingId;
        else
            args = 'payments=' + paymentsIds.join(',');
        DI.server.get('/api/payment/details?' + args).then(function (response) {
            details = response;
            for (var k in details.balance)
                details.balance[k] = Number(details.balance[k]);
            details.paid_amount = Number(details.paid_amount);
            details.payment_amount = Number(details.payment_amount);
            details.total_not_credited = Number(details.total_not_credited);
            if (details.cancelinfo && !DI.$rootScope.hasPermission('Credit payment')) {
                _this.form.course_no_refund = true;
            }
            recalculate();
            _this.form.products = [];
            if (details.cancelinfo) {
                _this.isBooking = true;
                _this.form.courseAmount = details.cancelinfo.course_amount;
                var discount_1 = 0;
                details.cancelinfo.payments.forEach(function (p) {
                    p.amount = -Number(p.amount);
                    if (!p.amount)
                        return;
                    if (p.type == 'discount')
                        discount_1 += p.amount;
                    else if (p.type == 'course')
                        return;
                    else if (p.hidePriceOnReceipt)
                        return; // Included products are display-only
                    else
                        _this.form.products.push(p);
                });
                if (discount_1)
                    _this.form.products.push({ name: 'Rabatt', amount: discount_1 });
            }
        });
        var recalculate = function () {
            if (courseBookingId) {
                if (details.cancelinfo) {
                    _this.form.fee = Number(details.cancelinfo.fee);
                    _this.form.paid_amount = Number(details.cancelinfo.paidAmount);
                    if (_this.form.course_no_refund) {
                        _this.form.amount = 0;
                    }
                    else {
                        if (_this.form.course_free_canceling) {
                            _this.form.amount = Number(details.cancelinfo.paidAmount);
                        }
                        else {
                            _this.form.amount = Number(details.cancelinfo.refundAmount);
                        }
                    }
                }
                else {
                    _this.form.paid_amount = details.paid_amount;
                    if (details.paid) {
                        _this.form.amount = details.payment_amount < details.paid_amount ? details.payment_amount : details.paid_amount;
                    }
                    else {
                        _this.form.amount = 0;
                    }
                }
            }
            else {
                _this.form.paid_amount = details.paid_amount;
                var amount = details.payment_amount < details.paid_amount ? details.payment_amount : details.paid_amount;
                var restPaymentAmount = details.total_not_credited - details.payment_amount;
                if (restPaymentAmount > 0) {
                    var maxRefund = details.paid_amount - restPaymentAmount;
                    if (maxRefund < 0)
                        amount = 0;
                    else
                        amount = amount > maxRefund ? maxRefund : amount;
                }
                _this.form.amount = amount;
            }
            // Special case:
            // If the payment amount equals the total not credited (last non-credited payment)
            // and the computed amount is negative (indicating a negative rounding adjustment),
            // then set the refund amount to 0 to allow the invoice to be refunded.
            if (details.total_not_credited == details.payment_amount && amount < 0) {
                _this.form.amount = 0;
            }
            updateMethods();
        };
        this.showFreeCancelling = function () {
            return Number(details.cancelinfo.paidAmount) != Number(details.cancelinfo.refundAmount);
        };
        this.setMethod = function (m) { return _this.activeMethod = m; };
        var getField = function (name) {
            return _.findWhere(_this.fields, { name: name }) || _.findWhere(_this.fields2, { name: name });
        };
        this.setInitialValues = function () {
            _.findWhere(_this.fields, { name: 'update_stock' }).value = true;
        };
        var isMethod = function (name) {
            return _this.activeMethod && _this.activeMethod.id == name;
        };
        function payoutAmount() {
            return details && details.paid_amount;
        }
        function visibleIfAutoPayouts() {
            return payoutAmount() && DI.$rootScope.hasModule('Payout') && isMethod('bank');
        }
        function chooseBankAccount() {
            if (!details || !details.payer_id) {
                return;
            }
            var payer = DI.$rootScope.getMember(details.payer_id);
            DI.get('BankAccount').selectDialog(payer).then(function (account) {
                getField('bankaccount').value = account;
            });
        }
        this.fields = [
            // {name: 'sendMail', title: 'E-mail', type: 'checkbox' },
            // {name: 'sendSms', title: 'SMS', type: 'checkbox', visible: function() { return DI.$rootScope.hasModule('SMS'); } },
            // {name: 'messageToCustomer', title: 'Message', type: 'textarea', visible: function() { return getField('sendMail').value || getField('sendSms').value; } },
            { hint: 'CREDITINVOICESTOCK', visible: function () { return details.hasStock; } },
            { name: 'update_stock', title: 'Update stock', type: 'checkbox', visible: function () { return details.hasStock; } }
        ];
        this.fields2 = [
            { name: 'nearest', title: 'Nearest possible day', required: false, type: 'checkbox', visible: visibleIfAutoPayouts },
            { name: 'date', title: 'Payment date', required: true, type: 'date', value: Date.today(), visible: function () { return visibleIfAutoPayouts() && !getField('nearest').value; } },
            { name: 'bankaccount', title: 'Account', required: true, visible: visibleIfAutoPayouts, type: 'customobject', useId: true,
                getName: function () { return this.value.fullname; }, buttonClick: chooseBankAccount, buttonTitle: 'Choose' },
            { name: '_', hint: 'REPAY_VALUECARD_HINT', hintClass: 'alert-info', visible: function () { return isMethod('bank') && payoutAmount() && !DI.$rootScope.hasModule('Payout'); } },
            { name: '_', hint: 'REPAY_VALUECARD_BANK_HINT', hintClass: 'alert-info', visible: function () { return visibleIfAutoPayouts() && getField('nearest').value; } }
        ];
        this.submit = function () {
            var request;
            var data = DI.util.getSubmitItem(_this.fields.concat(_this.fields2));
            data.amount = _this.form.amount;
            data.method = data.amount == 0 ? 'valuecard' : _this.activeMethod && _this.activeMethod.id;
            if (_this.form.course_free_canceling)
                data.free_canceling = _this.form.course_free_canceling;
            if (_this.form.course_no_refund)
                data.no_refund = _this.form.course_no_refund;
            _this.loadingStatus.loading = true;
            if (courseBookingId) {
                request = DI.server.post('/api/course/booking/remove', data, { id: courseBookingId });
            }
            else {
                if (bundleId)
                    data.bundle_id = bundleId;
                else
                    data.payments = paymentsIds;
                request = DI.server.post('/api/payment/refund', data, null, 'Payment was credited', 'Failed to credit payment');
            }
            request.then(function (result) {
                if (result.success) {
                    _this.$parent.$close();
                }
            })["finally"](function () {
                _this.loadingStatus.loading = false;
            });
        };
        this.getDialogTitle = function () {
            return DI.util.t(_this.isBooking ? 'CANCEL_BOOKING' : 'Credit payment');
        };
        this.getSubmitTitle = function () {
            if (_this.isBooking) {
                if (_this.form.amount > 0) {
                    return DI.util.t('Cancel and refund') + ' ' + DI.formatter.format('price', _this.form.amount);
                }
                else if (_this.form.amount < 0) {
                    return DI.util.t('Cancel and charge') + ' ' + DI.formatter.format('price', -_this.form.amount);
                }
                else {
                    return DI.util.t('Cancel without refund');
                }
            }
            return DI.util.t('Credit payment');
        };
        // Invoice credit where nothing is refunded (the selected row/payment was
        // not covered by any payment — e.g. an unpaid row on a partially paid
        // invoice). Explain that 0 kr is refunded and what actually happens.
        this.showZeroRefundInfo = function () {
            return !_this.isBooking && details.invoice_id && Number(_this.form.amount) === 0;
        };
        this.getZeroRefundInfo = function () {
            return DI.util.t('CREDIT_ZERO_REFUND_INFO').format(DI.formatter.format('price', Number(details.payment_amount)));
        };
        this.getTitle = function (name) {
            if (name) {
                return _.findWhere(_this.fields.concat(_this.fields2), { name: DI.$rootScope.getRealFormName(name) }).title;
            }
        };
    }
});
